import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const OrdersIcon = (props) => (
	<SvgIcon viewBox="0 0 20.054 18.5" {...props}>
		<path strokeMiterlimit="10" fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M15.278 10.95v6.8H.75v-17h14.528v5.564" />
		<path strokeMiterlimit="10" fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M6.623 7.55l3.709 3.709 8.964-8.964" />
		<path d="M3.532 5.077a.927.927 0 1 1 0-1.854.927.927 0 1 1 0 1.854zM12.496 4.768H6.623a.618.618 0 0 1 0-1.236h5.873a.618.618 0 0 1 0 1.236zM12.496 14.659H6.623a.618.618 0 0 1 0-1.236h5.873a.618.618 0 0 1 0 1.236zM3.532 10.023a.927.927 0 1 1 0-1.854.927.927 0 1 1 0 1.854zM3.532 14.968a.927.927 0 1 1 0-1.854.927.927 0 1 1 0 1.854z" />
	</SvgIcon>
);

export default OrdersIcon;



// WEBPACK FOOTER //
// ./src/icons/menu/OrdersIcon.jsx